import { render, staticRenderFns } from "./ExtPortfolio.vue?vue&type=template&id=152b3b12&"
import script from "./ExtPortfolio.vue?vue&type=script&lang=js&"
export * from "./ExtPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports